import {StoppageCodeType} from '@domain/shared'
import {AnalysisPrivacyStatus, AnalysisType} from '@hconnect/common/types'

export enum NewAnalysisStep {
  selectStoppageList,
  fillAnalysisForm,
  addContributors
}
export interface AnalysisContributorToBeSaved {
  id?: string
  name?: string
  email: string
}

export interface AnalysisToCreate {
  id?: number
  title: string
  description?: string
  areaTypeCode?: string
  category?: string
  contributors?: Array<AnalysisContributorToBeSaved>
  dueDate?: string
  equipmentName?: string
  externalGroupId?: string
  owner?: string
  plantUpmId?: string
  privacyStatus?: AnalysisPrivacyStatus
  stoppageCode?: string
  stoppageCodeType?: StoppageCodeType
  stoppageEnd?: string
  stoppageStart?: string
  type?: AnalysisType
}
